let aboutData = {
  heading: 'RC Medical',
  paragraph: 'Marka RC-Medical powstała w wyniku nawiązania współpracy i poszerzenia działalności Spółek Rue Cambon oraz Med Point, w odpowiedzi na potrzebę rynku, podyktowaną trwającą pandemią COVID - 19. Oferujemy przede wszystkim produkty jednorazowego użytku, które spełniają wymagane normy, są w pełni certyfikowane i gwarantują najwyższą jakość. Jesteśmy wyłącznym dystrybutorem produktów firmy MGI Medical.',
};

export { aboutData };